export const CROP_PRESETS = [
  { label: 'Portrait 4:5', ratio: 4 / 5 },
  { label: 'Square 1:1', ratio: 1 },
  { label: 'Landscape 1.91:1', ratio: 1.91 },
];

export function cropRect(width: number, height: number, ratio: number, zoom: number, centerX: number, centerY: number) {
  const cropWidth = Math.min(width, height * ratio) / zoom;
  const cropHeight = cropWidth / ratio;
  return {
    x: Math.max(0, Math.min(width - cropWidth, centerX - cropWidth / 2)),
    y: Math.max(0, Math.min(height - cropHeight, centerY - cropHeight / 2)),
    width: cropWidth,
    height: cropHeight,
  };
}

export async function cropPhoto(image: HTMLImageElement, rect: ReturnType<typeof cropRect>, name: string): Promise<File> {
  const canvas = document.createElement('canvas');
  // Never enlarge small originals. Match the crop preview exactly.
  const scale = Math.min(1, 1080 / rect.width);
  canvas.width = Math.max(1, Math.floor(rect.width * scale));
  const ratio = rect.width / rect.height;
  // Round toward Instagram's supported interval so the publisher does
  // not trim another edge because of a fractional pixel at 4:5 or 1.91:1.
  canvas.height = Math.max(1, ratio < 1 ? Math.floor(canvas.width / ratio) : Math.ceil(canvas.width / ratio));
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Photo cropping is unavailable in this browser.');
  context.fillStyle = 'white';
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.drawImage(image, rect.x, rect.y, rect.width, rect.height, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise<Blob>((resolve, reject) => canvas.toBlob(
    (result) => result ? resolve(result) : reject(new Error('Could not crop this photo. Try another image.')),
    'image/jpeg', 0.94,
  ));
  return new File([blob], `${name.replace(/\.[^.]+$/, '')}-cropped.jpg`, { type: 'image/jpeg' });
}
